module.exports = __webpack_public_path__ + "static/media/arrow-down-gray.4c46c7c6.svg";